
const getChildIds = require('@converdy/c-utils/get-child-ids')
import cloneDeep from 'lodash/cloneDeep'
import mapRecursivelyFromRootElements from './map-recursively-from-root-elements'
import replaceId from './replace-id'
import { wrapArray } from '@converdy/utils/'
import generateId from './generate-id'
import toObject from '@converdy/utils/to-object'
import deepValues from '@converdy/utils/deep-values'

export default function clone (rootIds, elements) {
	elements = cloneDeep(elements)

	rootIds = wrapArray(rootIds)

	const childIds = rootIds.map(rootId => getChildIds(rootId, elements)).flat(1)

	/* Replace rootIds and push new rootIds to newRootIds */
	const newRootIds = []

	rootIds.forEach(
		rootId => {
			const newId = generateId()

			newRootIds.push(newId)

			elements[newId] = elements[rootId]

			elements[newId].id = newId

			delete elements[rootId]

			if (elements[newId].slots) {
				deepValues(elements[newId].slots).forEach(
					id => elements[id].parentId = newId
				)
			}
		}
	)

	const newChildIds = childIds.map(childId =>	replaceId(childId, elements).newId)

	const clonedElements = toObject(
		element => element.id,
		element => element
	)(
		[...newRootIds, ...newChildIds ].map(id => elements[id])
	)

	return { 
		elements: clonedElements,
		rootIds: newRootIds
	}
}
